// removed by extract-text-webpack-plugin
module.exports = {"photographer":"_1Yquwqw6A1VKHh5pXWGaiI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PhotoCredit/PhotoCredit.module.scss
// module id = 794
// module chunks = 0